<template>
  <div v-if="text" class="text_explain flex-col">
    <div class="text_wrap">
      <span>
        {{ text }}
      </span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      default: ''
    }
  }
}
</script>
<style lang="scss">
.text_explain {
  padding: 17px 15px;
  background: #fbfbfb;
  height: 100%;
  border-bottom: 0.5px solid #f3f6f9;
  .text_wrap {
    height: 100%;
    overflow: auto;
    line-height: 21px;
    span {
      font-size: 14px;
      line-height: 21px;
      color: #333333;
      word-break: break-all;
    }
  }
}
</style>
